import React from 'react';
import Tooltip from '../Tooltip/Tooltip';

function IconButton({
  active = false,
  ariaLabel,
  children,
  className = '',
  disabled = false,
  size = 'medium',
  tooltip,
  type = 'button',
  variant = 'neutral',
  ...rest
}) {
  const accessibleLabel = ariaLabel || rest['aria-label'] || tooltip;

  const button = (
    <button
      aria-label={accessibleLabel}
      className={[
        'custom-icon-button',
        `custom-icon-button--${variant}`,
        `custom-icon-button--${size}`,
        active ? 'active' : '',
        className,
      ].filter(Boolean).join(' ')}
      disabled={disabled}
      type={type}
      {...rest}
    >
      {children}
    </button>
  );

  return tooltip ? <Tooltip label={tooltip}>{button}</Tooltip> : button;
}

export default IconButton;
